<template>
  <div class="cw-step-flow">
    <div class="step-container">
      <!-- Connection line background -->
      <div class="connection-line">
        <div
          class="connection-line-progress"
          :style="{ width: progressWidth }"
        ></div>
      </div>

      <!-- Steps -->
      <div v-for="(step, index) in steps" :key="step.id" class="step-item">
        <!-- Step circle -->
        <div class="step-circle" :class="getStepCircleClass(index + 1)">
          <i v-if="isCompleted(index + 1)" class="las la-check step-icon"></i>
          <span
            v-else
            class="step-number"
            :class="{ 'is-current': isCurrent(index + 1) }"
          >
            {{ index + 1 }}
          </span>
        </div>

        <!-- Step label -->
        <span class="step-label" :class="getLabelClass(index + 1)">
          {{ step.label }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'cw-step-flow',
  props: {
    steps: {
      type: Array,
      required: true,
      validator: steps => {
        return steps.every(
          step => step.id !== undefined && step.label !== undefined
        );
      },
    },
    currentStep: {
      type: Number,
      required: true,
      validator: value => value > 0,
    },
  },
  computed: {
    progressWidth() {
      if (this.steps.length <= 1) return '0%';
      const percentage =
        ((this.currentStep - 1) / (this.steps.length - 1)) * 100;
      return `${Math.min(Math.max(percentage, 0), 100)}%`;
    },
  },
  methods: {
    isCompleted(stepNumber) {
      return stepNumber < this.currentStep;
    },
    isCurrent(stepNumber) {
      return stepNumber === this.currentStep;
    },
    getStepCircleClass(stepNumber) {
      if (this.isCompleted(stepNumber)) {
        return 'is-completed';
      } else if (this.isCurrent(stepNumber)) {
        return 'is-current';
      }
      return 'is-upcoming';
    },
    getLabelClass(stepNumber) {
      if (this.isCompleted(stepNumber) || this.isCurrent(stepNumber)) {
        return 'is-active';
      }
      return 'is-inactive';
    },
  },
};
</script>

<style lang="stylus" scoped>
.cw-step-flow
  width 100%
  padding 1rem 0.5rem

  @media screen and (min-width: 769px)
    padding 1rem 1.5rem

.step-container
  display flex
  align-items flex-start
  justify-content space-between
  position relative

.connection-line
  position absolute
  top 1.25rem
  left 0
  right 0
  height 2px
  background-color #e5e5e5
  z-index 0

.connection-line-progress
  height 100%
  background-color #4e8793
  transition width 0.3s ease

.step-item
  display flex
  flex-direction column
  align-items center
  gap 0.5rem
  flex 1
  position relative
  z-index 1
  min-height 4rem

.step-circle
  width 2.5rem
  height 2.5rem
  border-radius 50%
  display flex
  align-items center
  justify-content center
  transition all 0.3s ease
  background-color white
  flex-shrink 0

  &.is-completed
    background-color #4e8793

  &.is-current
    background-color #4e8793
    box-shadow 0 0 0 4px rgba(78, 135, 147, 0.2)

  &.is-upcoming
    background-color white
    border 2px solid #e5e5e5

.step-icon
  font-size 1.25rem
  color white
  font-weight bold

.step-number
  font-size 0.875rem
  color rgba(46, 46, 46, 0.4)

  &.is-current
    color white

.step-label
  font-size 0.75rem
  text-align center
  max-width 5rem
  transition color 0.3s ease
  line-height 1.2
  word-break break-word
  hyphens auto

  @media screen and (min-width: 640px)
    font-size 0.875rem
    max-width none

  &.is-active
    color #2e2e2e

  &.is-inactive
    color rgba(46, 46, 46, 0.4)
</style>
